import { render, staticRenderFns } from "./editMovieGenre.vue?vue&type=template&id=6eb186d4&"
import script from "./editMovieGenre.vue?vue&type=script&lang=js&"
export * from "./editMovieGenre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports